/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { useEffect, useState } from 'react';

import { deploymentStates as states } from 'App/Pages/Diagram/features/deployment/utils';

export default function useDeploymentStates(isOpen) {
  const [currentState, setState] = useState(states.IDLE);
  const [failureMessage, setFailureMessage] = useState('');

  const reset = () => {
    setState(states.IDLE);
  };

  useEffect(() => {
    if (isOpen) {
      reset();
    }
  }, [isOpen]);

  const transitionToDeployingState = () => setState(states.DEPLOYING);

  const transitionToDeploymentFailedState = (message) => {
    setFailureMessage(message);
    setState(states.DEPLOYMENT_FAILED);
    setTimeout(() => {
      setState(states.DEPLOYMENT_FAILED_NOTIFICATION);
    }, 1000);
  };

  const transitionToRunningState = () => setState(states.RUNNING);

  const transitionToRunFailedState = (message) => {
    setFailureMessage(message);
    setState(states.RUN_FAILED);
    setTimeout(() => {
      setState(states.RUN_FAILED_NOTIFICATION);
    }, 1000);
  };

  return {
    currentState,
    failureMessage,
    reset,
    transitionToDeployingState,
    transitionToDeploymentFailedState,
    transitionToRunningState,
    transitionToRunFailedState
  };
}
